import { useTheme } from '@mui/system';

interface ImprovementIconProps {
  height?: number;
  width?: number;
  fill?: string;
}

export const ImprovementIcon = ({
  height = 32,
  width = 32,
  fill,
}: ImprovementIconProps) => {
  const theme = useTheme();
  const fillColor = fill || theme.palette.category.improvement;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <title>Improvement Icon</title>
      <path
        d="M25.7332 29.9996L18.1665 22.3996L21.8999 18.6329L29.4999 26.2329L25.7332 29.9996ZM6.76654 29.9996L2.99987 26.2329L12.4665 16.7329L10.1332 14.3996L9.16654 15.3663L7.8332 14.0996V16.3996L6.6332 17.5996L1.5332 12.4996L2.7332 11.2996H5.06654L3.76654 9.99961L9.19987 4.59961C9.71098 4.0885 10.2832 3.71072 10.9165 3.46628C11.5499 3.22183 12.1888 3.09961 12.8332 3.09961C13.4999 3.09961 14.161 3.22739 14.8165 3.48294C15.4721 3.7385 16.0443 4.11072 16.5332 4.59961L13.1332 7.96628L14.8332 9.66628L13.8332 10.6329L16.2332 12.9996L19.2999 9.93294C19.2332 9.73294 19.1832 9.49961 19.1499 9.23294C19.1165 8.96628 19.0999 8.72183 19.0999 8.49961C19.0999 7.01072 19.6165 5.74405 20.6499 4.69961C21.6832 3.65516 22.9443 3.13294 24.4332 3.13294C24.8999 3.13294 25.3499 3.1885 25.7832 3.29961C26.2165 3.41072 26.6443 3.5885 27.0665 3.83294L23.6332 7.29961L25.6665 9.33294L29.1332 5.83294C29.4221 6.23294 29.6054 6.66072 29.6832 7.11628C29.761 7.57183 29.7999 8.03294 29.7999 8.49961C29.7999 9.9885 29.2888 11.2496 28.2665 12.2829C27.2443 13.3163 25.9776 13.8329 24.4665 13.8329C24.2443 13.8329 24.0165 13.8107 23.7832 13.7663C23.5499 13.7218 23.3332 13.6774 23.1332 13.6329L6.76654 29.9996Z"
        fill={fillColor}
      />
    </svg>
  );
};
